import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../../app/config';

@Injectable()
export class WeatherProvider {
  constructor(public httpClient: HttpClient) {}

  get() {
    return this.httpClient.get(`${SERVER_API_URL}/weather`);
  }

  getLocation(location) {
    return this.httpClient.get(`${SERVER_API_URL}/weather/location/${location}`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/weather/weather.ts